import React from "react";
import { ScrollArea, Divider, Group, Button, Box, Text } from "@mantine/core";

import FilterDropdownSortSelector from "./FilterDropdownSortSelector";
import FilterDropdownFieldSelector from "./FilterDropdownFieldSelector";
import FilterDropdownValueSelector from "./FilterDropdownValueSelector";

export default function FilterSelectionPanel({
  filters,
  filtersSelected,
  isSortVisible,
  sortSelected,
  onSelectFilter,
  onUpdateFilter,
  onUpdateSort,
  onPressCreateFilter
}) {
  if (!Array.isArray(filters)) return null;

  const selectedIds = new Set(filtersSelected.map(f => f.id));
  const availableFilters = filters.filter(f => !selectedIds.has(f.id));

  return (
    <ScrollArea
      type="scroll"
      offsetScrollbars
      scrollbarSize={4}
      style={{ maxWidth: '90vw', width: '100%', height: 60, overflowX: 'auto' }}
    >
      <Group spacing={0} noWrap my={10}>
        {(isSortVisible || (Array.isArray(sortSelected) && sortSelected.length > 0)) && (
          <>
            <FilterDropdownSortSelector
              filters={availableFilters}
              sortSelected={sortSelected}
              onUpdateSort={onUpdateSort}
            />

            <Divider sx={{ height: '30px' }} ml={12} mr={12} orientation="vertical" />
          </>
        )}

        {filtersSelected.map((filter, index) => (
          <FilterDropdownValueSelector
            key={index}
            filter={filter}
            onUpdateFilter={(option_value) => {
              if (typeof onUpdateFilter === "function") {
                let newOptions = [];
                if (option_value !== null) {
                  const options = Array.isArray(filter.selectedOptions) ? filter.selectedOptions : [];
                  const findOption = options.find(value => value === option_value);
                  newOptions = findOption ? options.filter(value => value !== option_value) : [...options, option_value];
                }
                onUpdateFilter({...filter, selectedOptions: newOptions});
              }
            }}
          />
        ))}

        <FilterDropdownFieldSelector
          filters={availableFilters}
          onSelectFilter={onSelectFilter}
          onPressCreateFilter={onPressCreateFilter}
        />

        {filtersSelected.length > 0 && (
          <>
            <Button
              variant="default"
              radius="md"
              size="xs"
              sx={{
                backgroundColor: 'rgba(240, 240, 240, 0.2)',
                backdropFilter: 'blur(4px)',
                position: 'absolute',
                right: 0
              }}
              onClick={() => {
                if (typeof onUpdateFilter === "function") {
                  onUpdateFilter(null);
                }
              }}
            >
              <Text size="xs" color="grey">Reset</Text>
            </Button>
            <Box style={{ width: 100 }}></Box>
          </>
        )}

      </Group>

    </ScrollArea>
  );
}